import {Component} from 'react';
import {connect} from 'react-redux';
import Selector from '../selectors/layout';
import {bindActionCreators} from 'redux';
import {setMobile, initialize, initializePushNotifications, refreshNotificationsToken} from '../reducers/app/actions';
import {getUser, getTelegramUser, activateLoadedPromocode} from '../reducers/user/actions';
import {loadVipLevels} from '../reducers/vip/actions';
import {initialize as initializeModules} from '../reducers/modules/actions';
import {loadGames} from '../reducers/games/actions';
import {loadTournament} from '../reducers/tournaments/actions';
import {toggleActionModal, openActionModal} from '../reducers/modals-action/actions';
import Components from './components';
import Pages from './pages';
import {Routes, Route} from 'react-router-dom';
import SecureRoute from './components/secureRoute';
import WS from '../lib/websocket';
import Modals from './modals';
import ModalsAction from './modals-action';
import ModalsInfo from './modals-info';
import Intercom from '@intercom/messenger-js-sdk';
import Promotions from '../utils/promotions';
import FingerPrint from './fingerprint';
import ModalsLib from '../lib/modals';
import Blocker from './components/blocker';
import LocationUtil from './location-util';
import Triggers from '../lib/triggers';
import Modules from './modules';
import ModulesUtils from '../utils/modules';
import API from '../lib/api';
// import Snowfall from 'react-snowfall';

class Layout extends Component {
    constructor() {
        super();
    }

    documentClickHandler() {
        // if(this.props.isAuth)
        //     this.props.refreshNotificationsToken();
        // window.alert(`Hello`);
    }

    render() {
        const {isAuth, remote_details} = this.props;

        if(remote_details && remote_details.is_anonymous)
            return <Blocker.VPN details={remote_details} />;

        return (
            <>
                {/* <Snowfall
                    snowflakeCount={this.props.snowfall ? (this.props.is_mobile ? 100 : 200) : 0}
                    radius={[0.8, 2.2]}
                    speed={[0.5, 1.5]}
                    wind={[-0.3, 0.3]}
                    style={{
                        position: 'fixed',
                        zIndex: 99999
                    }}
                /> */}
                <Components.Loader.Full />
                <Modals />
                <ModalsAction />
                <ModalsInfo />
                <LocationUtil />

                {this.props.loaded && (
                    <>
                        <Components.Header />
                        <Components.MobileNav />
                        <Components.Sidebar />
                        <Components.LiveOperator />
                        <Components.Popups />
                        <Modules.LuckyWheel />
                        <Modules.ModuleModals />
                        <Modules.Modals />

                        <div className="container">
                            <Routes> 
                                <Route exact path='/' element={<Pages.Home />} />
                                <Route exact path='/tournament' element={<Pages.Tournament />} /> 
                                <Route exact path='/game/:game_slug' element={isAuth ? <Pages.Game /> : <SecureRoute />} />
                                {/* <Route exact path='/wheel' element={isAuth ? <Pages.Wheel /> : <SecureRoute />} /> */}
                                {/* <Route exact path='/vip' element={isAuth ? <Pages.VIP /> : <SecureRoute />} /> */}
                                <Route exact path='/vip' element={isAuth ? <Pages.VIP20 /> : <SecureRoute />} /> 
                                <Route exact path='/testyourluck' element={isAuth ? <Pages.TestYourLuck /> : <SecureRoute />} />
                                <Route exact path='/invite' element={isAuth ? <Pages.Invite /> : <SecureRoute />} />
                                <Route exact path='/freecash' element={isAuth ? <Pages.FreeCash /> : <SecureRoute />} />
                                <Route exact path='/tasks' element={isAuth ? <Pages.Tasks /> : <SecureRoute />} />
                                <Route exact path='/lootbox/:slug' element={isAuth ? <Pages.Lootbox /> : <SecureRoute />} />
                                <Route path='/payments/success' element={<Pages.Payments.Success />} />
                                <Route path='/payments/failed' element={<Pages.Payments.Fail />} />
                                <Route path='*' element={<Pages.NotFound />} />
                            </Routes>
                            <Components.Connection />
                        </div> 
                    </>
                )}
            </>
        )
    }

    resizeHandler() {
        const isTablet = window.document.body.offsetWidth < 1024,
              isMobile = window.document.body.offsetWidth <= 800;

        let state = 'desktop'; // Laptop / Desktop
        if(isTablet) state = 'tablet';
        if(isMobile) state = 'mobile';

        this.props.setMobile(state);
    }

    componentDidUpdate(prevProps) {
        const locationSearch = new URLSearchParams(window.location.search);

        if(!this.props.loaded) {
            if(!this.props.user) {
                if(typeof window.Telegram.WebApp.initDataUnsafe.user !== "undefined") {
                    window.Telegram.WebApp.ready();
                    window.Telegram.WebApp.expand();
                    this.props.getTelegramUser(window.Telegram.WebApp.initData);
                } else {
                    this.props.getUser();
                }
            } else if(!this.props.games) {
                this.props.loadGames();
            } else if(!this.props.vip_levels) {
                this.props.loadVipLevels();
            } else if(!this.props.notifications) {
                this.props.initializePushNotifications();
            } else if(!this.props.tournaments_loaded) {
                this.props.loadTournament()
            } else if(!this.props.modules_loaded) {
                this.props.initializeModules();
            }
        } else {       
            if(this.props.modules_loaded && !prevProps.modules_loaded)
                ModulesUtils.ModuleModals.init();


            // User is loaded
            if(this.props.isAuth && !prevProps.isAuth) {
                if(locationSearch.get('voucherRedeem'))
                    this.props.activateLoadedPromocode(locationSearch.get('voucherRedeem'));
                else if(locationSearch.get('openModal'))
                    ModalsLib.open(locationSearch.get('openModal'));
                else
                    setTimeout(() => {
                        Promotions.initializeModals();
                    }, 2000);   
                    // if(this.props.welcome_bonus_details.finalized) {
                    //     if(this.props.user_data && this.props.user_data.uncompleted_fields.length > 0) {
                    //         ModalsLib.open('profile_complete');
                    //     } else {
                    //         setTimeout(() => {
                    //             Promotions.initializeModals();
                    //         }, 2000);   
                    //     }
                    // } else {
                    //     this.props.openActionModal(this.props.welcome_bonus_details.way === 'affiliate' ? 'affiliate_signup' : 'welcome_package');
                    // }
            }

            // User found on page load
            if(!prevProps.loaded) {
                if(this.props.isAuth) {
                    setTimeout(() => {
                        Promotions.initializeModals();
                    }, 2000);   
                    // if(locationSearch.get('voucherRedeem'))
                    //     this.props.activateLoadedPromocode(locationSearch.get('voucherRedeem'));
                    // else if(locationSearch.get('openModal'))
                    //     ModalsLib.open(locationSearch.get('openModal'));
                    // else
                        // if(this.props.welcome_bonus_details.finalized) {
                        //     if(this.props.user_data && this.props.user_data.uncompleted_fields.length > 0) {
                        //         ModalsLib.open('profile_complete');
                        //     } else {
                        //         // setTimeout(() => {
                        //         //     Promotions.initializeModals();
                        //         // }, 2000);   
                        //     }
                        // } else {
                        //     this.props.openActionModal(this.props.welcome_bonus_details.way === 'affiliate' ? 'affiliate_signup' : 'welcome_package');
                        // }
                } else {
                    if(this.props.welcome_bonus_details.available) {
                        if(this.props.welcome_bonus_details.available.affiliate)
                            this.props.openActionModal('affiliate_signup');
                        else if(this.props.welcome_bonus_details.available.referral)
                            ModalsLib.open('signup');
                    }
                }
            }

            if(!prevProps.loaded) {
                if(this.props.isAuth && !prevProps.isAuth) {
                    setTimeout(() => {
                        Promotions.initializeModals();
                    }, 2000);   
                    // setTimeout(() => {
                    //     Promotions.initializeModals();
                    // }, 2000);   
                    // if(this.props.user && this.props.user.uncompleted_fields.length > 0) {
                    //     // ModalsLib.open('profile_complete');
                    // } else {
                    //     // window.alert(`Auth`);
                    //     setTimeout(() => {
                    //         Promotions.initializeModals();
                    //     }, 2000);   
                    // }
                } else {
                    // window.alert(`Loaded`);
                }
            }
        }
    }


    componentDidMount() {
        WS.connect();

        Triggers.register('app_open', {});

        window.addEventListener('resize', this.resizeHandler.bind(this));
        document.addEventListener('mouseup', this.documentClickHandler.bind(this));
        window.addEventListener('beforeinstallprompt', e => {});

        this.resizeHandler();

        if(!this.props.initialized)
            this.props.initialize();

        Triggers.initialize();
    }
}

export default connect(Selector, dispatch => bindActionCreators({
    getUser,
    getTelegramUser,
    loadGames,
    setMobile,
    initialize,
    initializePushNotifications,
    loadVipLevels,
    loadTournament,
    activateLoadedPromocode,
    toggleActionModal,
    openActionModal,
    refreshNotificationsToken,
    initializeModules
}, dispatch)) (Layout);